import React, { useRef, useEffect, useState } from 'react';
import { Canvas, useFrame,  } from '@react-three/fiber';
import { Sphere, useGLTF, OrbitControls } from '@react-three/drei';
import { BallCollider, Physics, RigidBody, Debug } from "@react-three/rapier"
import { TextureLoader } from 'three';
import * as THREE from 'three';


THREE.ColorManagement.legacyMode = false
const baubles = [...Array(2)].map(() => ({ scale: 3 }))




function Bauble({ vec = new THREE.Vector3(), scale, r = THREE.MathUtils.randFloatSpread }) {

  const api = useRef()
  const { nodes, materials } = useGLTF("/model/lego.glb")

  useFrame((state, delta) => {
    delta = Math.min(0.1, delta)
    if (api.current){
      api.current.applyImpulse(
        vec
          .copy(api.current.translation())
          .normalize()
          .multiply({ x: -50 * delta * scale, y: -150 * delta * scale, z: -50 * delta * scale })
      )}
  })

  useEffect(() => {
    Object.values(materials).forEach((material) => {
      material.side = THREE.FrontSide; // 表面のみ描画

      
    });
  }, [materials]);

  
  

  return (

    <>
      <RigidBody 
        mass={1 / scale}
        linearDamping={1/ scale} 
        angularDamping={1} 
        friction={0.2} 
        position={[r(20), r(20) - 25, r(20) - 10]} 
        ref={api} 
        dispose={null}
        scale={scale}
        
        >
       
      
        <group dispose={null} >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.face.geometry}
            material={materials.body}
            rotation={[0, -0.227, 0]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker11.geometry}
            material={materials.sticker12}
            position={[0, 0.21, -0.01]}
            rotation={[-0.57, -0.533, -1.812]}
            scale={0.301}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker1.geometry}
            material={materials.sticker2}
            rotation={[1.006, -0.435, -0.983]}
            scale={0.444}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker10.geometry}
            material={materials.sticker10}
            rotation={[0.734, -0.405, -1.229]}
            scale={0.32}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker12.geometry}
            material={materials.sticker12}
            position={[0, 0.26, 0]}
            rotation={[1.128, -0.136, 2.026]}
            scale={0.301}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker2.geometry}
            material={materials.sticker2}
            position={[-0.017, 0.18, -0.001]}
            rotation={[2.019, 0.555, 2.401]}
            scale={0.444}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker3.geometry}
            material={materials.sticker3}
            position={[0, -0.2, 0]}
            rotation={[2.16, -0.078, -1.687]}
            scale={0.698}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker4.geometry}
            material={materials.sticker5}
            rotation={[1.314, 0.049, 1.385]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker5.geometry}
            material={materials.sticker5}
            position={[0, -0.08, 0]}
            rotation={[1.667, 0.939, 3.023]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker6.geometry}
            material={materials.sticker6}
            position={[0, 0.16, 0]}
            rotation={[0.891, 0.357, 1.069]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker7.geometry}
            material={materials.sticker6}
            position={[0, -0.13, 0]}
            rotation={[0.937, -0.433, 2.09]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker8.geometry}
            material={materials.sticker8}
            position={[0, 0.13, 0]}
            rotation={[1.42, 0.171, -2.413]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker1002.geometry}
            material={materials.sticker1}
            rotation={[1.223, -0.03, 1.653]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker2002.geometry}
            material={materials.sticker2}
            position={[0, 0.16, 0]}
            rotation={[1.009, 0.132, -1.777]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker5002.geometry}
            material={materials.sticker5}
            position={[0, 0.15, 0]}
            rotation={[1.565, 0.271, -0.234]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker3002.geometry}
            material={materials.sticker3}
            position={[0, -0.28, 0]}
            rotation={[0.66, -0.679, -1.021]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker9002.geometry}
            material={materials.sticker9}
            position={[0, -0.17, 0]}
            rotation={[1.448, 0.309, -2.756]}
            scale={0.438}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker4002.geometry}
            material={materials.sticker4}
            position={[0, -0.02, 0]}
            rotation={[1.505, -1.137, 1.364]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker10002.geometry}
            material={materials.sticker10}
            rotation={[-2.645, -1.236, -1.098]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker8002.geometry}
            material={materials.sticker8}
            position={[0, 0.33, 0]}
            rotation={[1.01, -0.089, -0.056]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.sticker7002.geometry}
            material={materials.sticker7}
            position={[0, 0.5, 0]}
            rotation={[1.717, -0.035, -1.19]}
          />
        </group>
        


      </RigidBody>

   
    
    </>
    

    
  )
}



function Pointer({ vec = new THREE.Vector3() }) {
  const ref = useRef();

  useEffect(() => {
    const handleMouseMove = (event) => {
      const { innerWidth, innerHeight } = window;
      const x = (event.clientX / innerWidth) * 2 - 1; // -1 to 1 range
      const y = -(event.clientY / innerHeight) * 2 + 1; // -1 to 1 range
      vec.set(x, y, 0);
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [vec]);

  useFrame(() => {
    ref.current?.setNextKinematicTranslation(vec);
  });

  return (
    <RigidBody
      position={[0, 0, 0]}
      type="kinematicPosition"
      colliders={false}
      ref={ref}
    >
      <BallCollider args={[1]} />
    </RigidBody>
  );
}





function BackgroundCanvas() {

  
  return (
    <>
      
      <Canvas className={'canvas backGroundCanvas'} 
        shadows
        gl={{ alpha: true, antialias: false }}
        camera={{ position: [0, 0, 10], fov: 32.5, near: 1, far: 100 }}
      >


        {/* <OrbitControls /> */}
        <ambientLight intensity={2} />
        <directionalLight castShadow receiveShadow position={[0.3, .5, .2]} angle={0.15} penumbra={1} intensity={3} />

        <Physics gravity={[0, 0, 0]}   >
          <Pointer />
          {baubles.map((props, i) => <Bauble key={i} {...props} />)}
        </ Physics>
        
      </Canvas>

    </>
  )
}



export default BackgroundCanvas